<div class="wrapper-list-search-accounts" #listersContainer (scroll)="onScroll()">
  <span class="title-search-results">{{'NEW_TEXT.users' | translate}}</span>
  <div >
    <div class="wrapper-card-lister" *ngFor="let user of listers">
      <div class="wrapper-favorite-lister" [routerLink]="[PAGES_AND_PATHS.profile.pagePath, user.username]">
        <div class="wrapper-avatar">
          <img
            [src]="user.profile_photo_url !== null ? user.profile_photo_url :
            '../../../../assets/images/avatar-user.png'"
            alt="">
        </div>
        <div class="wrapper-user-info">
          <div class="wrapper-username">
            <span>{{user.name}}</span>
            <img *ngIf="(user?.subscriptions | checkActiveRole) === UserRoles.expert"
                 src="../../../../assets/icons/fill/icon-badge.svg" alt="">
          </div>
          <span>{{user?.followers_count}} {{user.followers_count === 1 ? ('GENERAL.followers' | translate) : ('GENERAL.followers' | translate)}}</span>
        </div>
      </div>
    </div>
  </div>
</div>
